/**
 * REVIEW LINK CUSTOM ELEMENT
 *
 * Scrolls to the Klaviyo reviews app block. The href target
 * (#klaviyo-product-reviews-wrapper) is created by Klaviyo's own script after load, so this
 * falls back to the Shopify app-block wrapper, which is in the server HTML from first paint.
 */

const RENDERED_TARGET = '#klaviyo-product-reviews-wrapper'
const APP_BLOCK_TARGET = '[id*="klaviyo_reviews_product_reviews"]'

class ReviewLinkElement extends HTMLElement {
  constructor() {
    super()

    this.handleClick = (event) => {
      const target = document.querySelector(RENDERED_TARGET) || document.querySelector(APP_BLOCK_TARGET)
      if (!target) return

      event.preventDefault()

      // Clears the sticky header, which would otherwise cover the top of the reviews.
      const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--height-header-adapt')
      target.style.scrollMarginTop = headerHeight ? headerHeight.trim() : ''

      target.scrollIntoView({ block: 'start' })
    }
  }

  connectedCallback() {
    this.link = this.querySelector('a')
    this.link?.addEventListener('click', this.handleClick)
  }

  disconnectedCallback() {
    this.link?.removeEventListener('click', this.handleClick)
  }
}

customElements.define('x-review-link', ReviewLinkElement)
